import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store/RootState'
import { initialState } from './slice'

const selectDomain = (state: RootState) => state.user || initialState

export const selectUser = createSelector([selectDomain], user => user)
